import { Check, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface SubscriptionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SubscriptionModal({ open, onOpenChange }: SubscriptionModalProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Sparkles className="h-6 w-6 text-warning" />
            <DialogTitle>12-Month Bill Collection</DialogTitle>
          </div>
          <DialogDescription>
            Automatically collect bills for the past 12 months from supplier portals
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-4">
          <div className="flex items-center gap-2">
            <Check className="h-4 w-4 text-success flex-shrink-0" />
            <span className="text-sm">Historical bill retrieval (12 months)</span>
          </div>
          <div className="flex items-center gap-2">
            <Check className="h-4 w-4 text-success flex-shrink-0" />
            <span className="text-sm">Batch downloads</span>
          </div>
          <div className="flex items-center gap-2">
            <Check className="h-4 w-4 text-success flex-shrink-0" />
            <span className="text-sm">Automated scheduling</span>
          </div>
          <div className="flex items-center gap-2">
            <Check className="h-4 w-4 text-success flex-shrink-0" />
            <span className="text-sm">Priority support</span>
          </div>
        </div>

        <Alert>
          <AlertDescription>
            This feature is available on Pro and Enterprise plans
          </AlertDescription>
        </Alert>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={() => navigate('/billing')}>
            Upgrade to Pro
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
